import {createSlice} from '@reduxjs/toolkit';

// ---- import from local actions ----
import {fetchApplyList} from './../actions/ApplyActions';


const ApplySlice = createSlice({
  name: 'apply',
  initialState: {
    applDetailList: {
      data: [],
      status: 'idle',
      error: '',
      loading: false,
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchApplyList.pending, (state) => {
        state.applDetailList.status = 'loading';
      })
      .addCase(fetchApplyList.fulfilled, (state, action) => {
        state.applDetailList.status = 'idle';
        state.applDetailList.data = action.payload.result;
      })
      .addCase(fetchApplyList.rejected, (state, action) => {
        state.applDetailList.status = 'rejected';
        state.applDetailList.error = action.error.message;
      });
  },
});

export default ApplySlice.reducer;
